import type { AdHocFilter, MatchType } from "@domains/segments/shared/segmentsTypes.ts";
import { useSyncExternalStore } from "react";

export const TEAM_FILTER_MATCH_TYPE: MatchType = "all";

interface AppliedTeamFilter {
    filter: AdHocFilter;
    draft: AdHocFilter;
}

let applied: AppliedTeamFilter | null = null;
const listeners = new Set<() => void>();

function emit() {
    for (const listener of listeners) {
        listener();
    }
}

function subscribe(listener: () => void) {
    listeners.add(listener);

    return () => {
        listeners.delete(listener);
    };
}

export function setTeamAdHocFilter(next: AppliedTeamFilter | null) {
    applied = next;
    emit();
}

export function useTeamAdHocFilter(): AdHocFilter | null {
    return useSyncExternalStore(
        subscribe,
        () => applied?.filter ?? null,
        () => null
    );
}

export function useTeamAdHocDraft(): AdHocFilter | null {
    return useSyncExternalStore(
        subscribe,
        () => applied?.draft ?? null,
        () => null
    );
}
